import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { vehicleGroupSchema } from '../schemas/vehicle-group.schema';

/**
 * Returns a paginated response for Vehicle Groups
 * @param params Paged Collection Params
 * @returns Paged Collection of Vehicle Groups
 */
export function getVehicleGroups(
  this: unknown,
  params?: PagedCollectionParams,
  excludeEmptyGroups?: boolean
) {
  let pagedParams = params ? params.urlParams : '';
  if (excludeEmptyGroups ?? false) {
    pagedParams +=
      pagedParams === ''
        ? 'excludeEmptyGroups=true'
        : '&excludeEmptyGroups=true';
  }
  const requestUrl = `${fleetEnvironment.resolve(this).vehicleGroupsUrl}?${
    pagedParams
  }`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(vehicleGroupSchema)));
}
